import { createFileRoute } from "@tanstack/react-router";

/** `?branch=&date=` — the nightly "đơn lệch set" bell opens the board on the right branch and day (QĐ 0542). */
export type SetBoardSearch = { branch?: string; date?: string };

export const Route = createFileRoute("/_app/set-board")({
  validateSearch: (search: Record<string, unknown>): SetBoardSearch => ({
    ...(typeof search.branch === "string" && search.branch ? { branch: search.branch } : {}),
    ...(typeof search.date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(search.date) ? { date: search.date } : {}),
  }),
});
